import { Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '@core/services/toast.service';
import { SelectMeasureComponent } from '@shared/components/dropdowns/select-measure/select-measure.component';
import { SelectLevelComponent } from '@shared/components/dropdowns/select-level/select-level.component';
import { IActivityBankAddDto } from '@core/interfaces/iactivity-bank';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'drdp-add-activity-bank',
  templateUrl: './add-activity-bank.component.html',
  styleUrls: ['./add-activity-bank.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddActivityBankComponent implements OnInit {
  @ViewChild('measureSelect') measureSelect: SelectMeasureComponent | undefined;
  @ViewChild('levelSelect') levelSelect: SelectLevelComponent | undefined;

  activityForm: FormGroup | any;
  selectedMeasureId: number | null = null;
  selectedLevelId: number | null = null;
  clearMeasure = false;
  isSpanish = false;

  get description() {
    return this.activityForm.get('description');
  }

  get spanishDescription() {
  return this.activityForm.get('spanishDescription');
}

  constructor(
    public dialogRef: MatDialogRef<AddActivityBankComponent>,
    private fb: FormBuilder,
    private toast: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translocoService: TranslocoService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.initializeForms();
  }

  initializeForms(): void {
    this.activityForm = this.fb.group({
      description: [null, [Validators.required]],
      spanishDescription: ['']  
    });
  }

  onMeasureSelect(event: any): void {
    if (Array.isArray(event)) {
      this.selectedMeasureId = event.length > 0 ? event[0].id : null;
    } else {
      this.selectedMeasureId = event?.id || null;
    }
  }

  onLevelSelect(event: any): void {
    if (Array.isArray(event)) {
      this.selectedLevelId = event.length > 0 ? event[0].id : null;
    } else {
      this.selectedLevelId = event?.id || null;
    }
  }

  onSubmit(): void {
    if (this.activityForm.invalid || !this.selectedMeasureId || !this.selectedLevelId) {
      this.toast.error(this.translocoService.translate('configuration.activityBank.form.requiredFieldsToast'));
      return;
    }

    const payload: IActivityBankAddDto= {
      masterDomainId: this.data.domainId,
      masterMeasureId: this.selectedMeasureId,
      masterDevelopmentalLevelId: this.selectedLevelId,
      activity: this.description.value,
      spanishActivity: this.spanishDescription.value
    };

    this.dialogRef.close({ formValid: true, payload: payload });
  }
}